import ICompanyInfo from '@/types/ICompanyInfo';
import CompanyRepository from '@/repositories/CompanyRepository';
import CompanyFactory from '@/factories/CompanyFactory';
import ICompanyForm from '@/types/ICompanyForm';
import ICompanySettingsForm from '@/types/ICompanySettingsForm';


export default class CompanyService {
  static async getCompanyInfo(): Promise<ICompanyInfo> {
    const {data} = await CompanyRepository.fetchCompanyInfo()
    return CompanyFactory.toCompanyInfo(data)
  }

  static async updateCompanyAddress(data: ICompanyForm): Promise<any> {
    return CompanyRepository.updateCompanyAddress(data)
  }

  static async updateCompanySettings(data: ICompanySettingsForm): Promise<any> {
    return CompanyRepository.updateCompanySettings(data)
  }

}
